import {FieldConfigName} from '../../models';
import {Directive, Input} from '@angular/core';

@Directive()
export class FieldControlMaster {
  @Input() control: FieldConfigName;
  @Input() indexControl: number;
}
